/**
 * @generated SignedSource<<c7037ef6131abbd4599c6f2bc9318aa7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TrackContentViewInput = {
  contentUsageId: string;
};
export type useTrackContentViewMutation$variables = {
  input: TrackContentViewInput;
};
export type useTrackContentViewMutation$data = {
  readonly trackContentView: {
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type useTrackContentViewMutation = {
  response: useTrackContentViewMutation$data;
  variables: useTrackContentViewMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TrackContentViewResponse",
    "kind": "LinkedField",
    "name": "trackContentView",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReportingContentView",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTrackContentViewMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTrackContentViewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "760d8ded91a784d543cf598062cec169",
    "id": null,
    "metadata": {},
    "name": "useTrackContentViewMutation",
    "operationKind": "mutation",
    "text": "mutation useTrackContentViewMutation(\n  $input: TrackContentViewInput!\n) {\n  trackContentView(input: $input) {\n    node {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c384971d4c006aeff3b33bbedb51cd97";

export default node;
